import { isGermanLanguage } from './language';

export const getPersonalFormulaTitle = (t, name, language) => {
  if (!isGermanLanguage(language)) return t('PersonalFormula', { name: name?.split(' ')[0] });

  const firstName = name?.trim().split(/\s+/)[0] || '';

  if (!firstName) return t('PersonalFormulaWithoutName');

  return t('PersonalFormula', { name: firstName });
};

export const getPersonalFormulaReadyText = (t, name, language) => {
  const trimmedName = name?.trim() || '';

  if (!isGermanLanguage(language)) return `${trimmedName}, ${t('PersonalFormulaReady')}`;
  if (!trimmedName) return t('Product_FormulaReadyWithoutName');

  return t('Product_FormulaReady', { name: trimmedName.split(/\s+/)[0] });
};
